import React from 'react';
import BroncoSDK from 'Vulture/lib/BroncoSDK.js';
import { broncoURL } from 'Vulture/ENV.js';
import { getSession } from 'Vulture/Session.js';
import style from './ProofOfPlay.module.css';
import { embedDashboard } from '@superset-ui/embedded-sdk';

const broncoSDK = new BroncoSDK({
    baseURL: broncoURL
});

class ProofOfPlayView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            supersetHost: '',
            guestToken: '',
            dashboardId: '',
            isLoading: false,
            error: null
        };

        // We might store the interval ID so we can clear it on unmount
        this.iframeIntervalId = null;
    }

    componentDidMount() {
        const session = getSession();
        broncoSDK.setAuth(session.session, session.user);

        this.fetchGuestTokenAndEmbedDashboard();
    }

    componentWillUnmount() {
        // Clean up the interval if it was set
        if (this.iframeIntervalId) {
            clearInterval(this.iframeIntervalId);
        }
    }

    async fetchGuestTokenAndEmbedDashboard() {
        this.setState({ isLoading: true });
        try {
            const analyticsData = await broncoSDK.getAnalyticsProofOfPlay();
            if (analyticsData.status === 'SUCCESS') {
                const { guestToken, host, dashboardId } = analyticsData.data;
                this.setState(
                    { supersetHost: host, guestToken: guestToken, dashboardId: dashboardId, isLoading: false },
                    () => this.embedSupersetDashboard()
                );
            } else {
                console.error('Failed to fetch guest token:', analyticsData.message);
                this.setState({
                    error: 'Failed to fetch guest token',
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('Error fetching guest token:', error);
            this.setState({
                error: 'Error fetching guest token',
                isLoading: false
            });
        }
    }

    // Convert this to an async function
    async embedSupersetDashboard() {
        const { supersetHost, guestToken, dashboardId } = this.state;
        const supersetContainer = document.getElementById('analyticsContainer');

        if (!supersetContainer || !guestToken || !supersetHost || !dashboardId) {
            console.log('Superset container, host, or token is missing');
            if (!supersetContainer) console.error('Superset container is missing');
            if (!guestToken) console.error('Guest token is missing');
            if (!dashboardId) console.error('DashboardId is missing');
            if (!supersetHost) console.error('Superset host is missing');
            return;
        }

        try {
            // Await the Promise returned by embedDashboard
            const myDashboard = await embedDashboard({
                id: dashboardId,
                supersetDomain: supersetHost,
                mountPoint: supersetContainer,
                fetchGuestToken: () => Promise.resolve(guestToken),
                dashboardUiConfig: {
                    hideTitle: true,
                    filters: { expanded: true },
                    urlParams: {}
                },
                iframeSandboxExtras: [
                    'allow-top-navigation',
                    'allow-popups-to-escape-sandbox'
                ]
            });

            // ---- Iframe Size Adjustment Code ----
            // Example: poll every 1s for the dashboard's scroll size and update the iframe.
            // this.iframeIntervalId = setTimeout(async () => {
            //     try {
            //         const { width, height } = await myDashboard.getScrollSize();
            //         const iframeEl = supersetContainer.querySelector('iframe');
            //         if (iframeEl) {
            //             iframeEl.style.width = `${width}px`;
            //             iframeEl.style.height = `${height}px`;
            //         }
            //     } catch (err) {
            //         console.error('Error adjusting iframe size:', err);
            //     }
            // }, 3000);
            // -------------------------------------

        } catch (err) {
            console.error('Error embedding dashboard:', err);
            this.setState({ error: 'Error embedding dashboard' });
        }
    }

    renderAnalytics() {
        const { isLoading, error } = this.state;
        if (isLoading) {
            return <div className={style.loading}>Loading analytics...</div>;
        }
        if (error) {
            return <div className={style.error}>{error}</div>;
        }

        // **Always** render the container so it exists in the DOM
        return (
            <div id="analyticsContainer" className={style.analyticsContainer}>
                {/* Superset dashboard will be embedded here */}
            </div>
        );
    }

    render() {
        const { showSuccessMessage, showErrorMessage } = this.state;
        return (
            <div className={style.container}>
                {showSuccessMessage && (
                    <div className={style.successMessage}>
                        Operation completed successfully
                    </div>
                )}
                {showErrorMessage && (
                    <div className={style.errorMessage}>
                        An error occurred during the operation
                    </div>
                )}

                {this.renderAnalytics()}
            </div>
        );
    }
}

window.CrowFormField['custom.vulture.proof_of_play'] = ProofOfPlayView;
export default ProofOfPlayView;